import React from 'react';
import VoucherForm from './VoucherForm'; // Adjust path if needed
import { useParams } from 'react-router-dom';

const EditVoucherPage = () => {
    const { id } = useParams(); // Get ID from URL
    
    // Renders the form in 'edit' mode (which will be read-only if it's a system voucher)
    return id ? <VoucherForm formType="edit" currentVoucherId={id} /> : <div>Loading...</div>;
};

export default EditVoucherPage;